import { ArrowRightIcon } from "@heroicons/react/20/solid"
import flower from "@/(front-desk)/assets/gif/flower.gif"
export default function StatusBar(props) {

    const { children, pattern } = props

    return (
        <div className="flex flex-wrap items-center justify-between gap-3 p-6 w-full border border-black-300 bg-white rounded-[0.5rem] text-[1.125rem] text-black-900 font-semibold">
            {/* { pattern
                ?
                <img className="w-[2.5rem] h-[2.5rem]" src={flower.src} alt="" />
                :
                <ArrowRightIcon className="w-5 h-5" />
            } */}
            {/* <div className="flex items-center gap-3 w-full justify-between"> */}
                { children }
            {/* </div> */}
        </div>
    )
}